import { call, put, takeLatest, all } from 'redux-saga/effects';
import axios from 'axios';
import * as Actions from '../../actions';
import { showToast } from 'app/store/actions/fuse';

function* fetchAppResources(action) {
	const { applicationId } = action.payload;
	try {
		const response = yield call(() => axios.get(`/api/v1/applications/${applicationId}/resources`));
		yield put(Actions.fetchAppResourcesSuccess(response.data));
	} catch (error) {
		yield put(Actions.fetchAppResourcesFailure());
		showToast.error('Unable to Retrieve Application Resources: ' + error);
	}
}

function* deleteResources(action) {
	const { resourceIds, applicationId } = action.payload;

	try {
		yield call(() => axios.patch('/api/v1/resources?resourcePatchOperation=Delete', resourceIds));
		yield put(Actions.deleteResourcesSuccess());

		yield put(Actions.fetchAppResources({ applicationId }));

		showToast.success('Resources Deleted');
	} catch (error) {
		yield put(Actions.deleteResourcesFailure());

		showToast.success('Unable to Delete Resources: ' + error);
	}
}

function* watchResources() {
	yield all([ takeLatest(Actions.fetchAppResources, fetchAppResources) ]);
	yield all([ takeLatest(Actions.deleteResources, deleteResources) ]);
}

export default watchResources;
